import { WidgetSize } from './types';

export const defaultWidgetSize: WidgetSize = {
  height: 320,
  width: 420,
};
